import {
    ItemStatusEnum,
    EquipmentEnum,
    QuestionTypeEnum,
    EvaluationStatusEnum,
    AnalysisStatusEnum,
} from "@/common/types/enum";

export const enums = {
    item_status: {
        [ItemStatusEnum.AVAILABLE]: "Disponível",
        [ItemStatusEnum.UNAVAILABLE]: "Indisponível",
        [ItemStatusEnum.RESERVED]: "Reservado",
        [ItemStatusEnum.IN_USE]: "Em uso",
        // [ItemStatusEnum.USED]: "Usado",
        [ItemStatusEnum.DEFECT]: "Defeito",
        [ItemStatusEnum.BROKEN]: "Quebrado",
    },
    equipment_type: {
        [EquipmentEnum.ACCESSORY]: "Acessório",
        [EquipmentEnum.EQUIPMENT]: "Equipamento",
    },
    question_type: {
        [QuestionTypeEnum.TITLE]: "Título",
        [QuestionTypeEnum.INPUT]: "Texto",
        [QuestionTypeEnum.TEXTAREA]: "Área de Texto",
        [QuestionTypeEnum.SELECT]: "Selecionar",
        [QuestionTypeEnum.RADIO]: "Opçoes",
        [QuestionTypeEnum.CHECKBOX]: "Checkbox",
        [QuestionTypeEnum.PHOTO]: "Foto",
    },
    evaluation_status: {
        [EvaluationStatusEnum.CANCELED]: "Cancelado",
        [EvaluationStatusEnum.CONCLUDED]: "Concluído",
        [EvaluationStatusEnum.FINISHED]: "Finalizado",
        [EvaluationStatusEnum.PENDING]: "Pendente",
        [EvaluationStatusEnum.STARTED]: "Iniciado",
    },
    analysis_status: {
        [AnalysisStatusEnum.CANCELED]: "Cancelado",
        [AnalysisStatusEnum.CONCLUDED]: "Concluído",
        [AnalysisStatusEnum.PAUSED]: "Pausado",
        [AnalysisStatusEnum.PENDING]: "Pendente",
        [AnalysisStatusEnum.STARTED]: "Iniciado",
    },
};